module.exports = __webpack_public_path__ + "static/images/smoothness/ui-icons_2e83ff_256x240.png";